import { API_URL } from '../../helpers/constants';

export async function messagingRequest(path, body, method = body === undefined ? 'GET' : 'POST') {
  const response = await fetch(API_URL + '/messaging' + path, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-MHC-Messaging': '1' },
    ...(body === undefined ? {} : { body: JSON.stringify(body) })
  });
  let data;
  try {
    data = await response.json();
  } catch (_) {
    throw new Error('Messaging is unavailable. Refresh the page or contact your administrator.');
  }
  if (!response.ok) throw new Error(data.message || 'Messaging could not complete this action.');
  return data;
}
export function requestKey() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}
export const freshDraft = storeId => ({
  name: '',
  channel: 'sms',
  storeId: storeId || '',
  subject: '',
  body: '',
  link: '',
  filters: {}
});
export const readable = value =>
  String(value || '')
    .replace(/_/g, ' ')
    .replace(/^\w/, c => c.toUpperCase());
export const dateLabel = value =>
  value ? new Date(value).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '—';

// Use the CRM location label (usually its city), not the shared legal company name.
export const storeLocationLabel = store =>
  [store?.location, store?.city, store?.name]
    .map(value => (typeof value === 'string' ? value.trim() : ''))
    .find(Boolean) || 'Location not set';
